import {Bar} from 'vue-chartjs'

export default {
    extends: Bar,
    data() {
        return {
            query: '',
            stop: false,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                showTooltips: false,
                showInlineValues: true,
                centeredInllineValues: true,
                scales: {
                    xAxes: [{
                        stacked: true,
                        categoryPercentage: 0.5,
                        barPercentage: 1
                    }],
                    yAxes: [{
                        stacked: true
                    }]
                }
            },
            delay: [],
            labels: []
        }
    },
    methods: {
        render() {
            this.renderChart({
                labels: this.labels,
                datasets: [
                    {
                        type: 'bar',
                        label: 'Delay',
                        tooltipTemplate: 'ddd',
                        backgroundColor: 'orange',
                        data: this.delay,
                    }
                ]
            }, this.options);
        },
        init(data) {
            this.labels = [];
            this.delay = [];
            data.forEach(e => {
                this.labels.push(Number.parseInt(e.hour));
                this.delay.push(Number.parseInt(e.delay));
            });
            this.render();
        }
    }
};